import React from "react";

type Props = {
    subtitle: string;
}
export const Subtitle = ({subtitle}: Props) => {
    return <h2 className={'pt-2 pb-2 subtitle'}>{subtitle}</h2>
}
